<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <input type="text"
           class="form-control"
           :name="name"
           :required="required"
           :disabled="disabled"
           :placeholder="placeholder"
           :value="value"
           v-mask="'(99)9999[9]-9999'"
           @input="updateValue($event.target.value)"
           @blur="updateValue($event.target.value)"
    >
    <span v-if="error"
          class="help-block"
          v-html="error"
    ></span>
  </div>
</template>

<script>
  export default{
    name: 'InputPhone',
    props: ['name', 'value', 'required', 'label', 'placeholder', 'error', 'disabled'],
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputPhone.vue?1fdc2a63